import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import axios from "../../services/axios";
import { toast } from "react-toastify";
import api from "../../services/axios";

const AdminPage = () => {
  const navigate = useNavigate();
  const { firstName, lastName, role, userId } = useAuth();

  useEffect(() => {
    if (role !== "ADMIN") {
      navigate("/", { replace: true });
    }
  }, [role, navigate]);

  const handleDeleteAllBooks = async () => {
    const confirmed = window.confirm(
      "Voulez-vous vraiment supprimer tous les livres ?"
    );
    if (!confirmed) return;

    try {
      await api.delete("/books/all");
      toast.info("Tous les livres ont été supprimés.");
    } catch (error) {
      toast.error("Une erreur est survenue.");
    }
  };
  const handleChangeSecondaryPassword = () => {
    toast.info(
      "Fonctionnalité à venir : modification du mot de passe secondaire."
    );
  };

  return (
    <div className="max-w-3xl mx-auto mt-12 p-6 bg-white shadow-lg rounded-xl space-y-8">
      <h1 className="text-2xl font-bold text-gray-800 text-center">
        Espace Administrateur
      </h1>

      <div className="space-y-2">
        <p>
          <span className="font-semibold">Nom :</span> {lastName}
        </p>
        <p>
          <span className="font-semibold">Prénom :</span> {firstName}
        </p>
        <p>
          <span className="font-semibold">Rôle :</span> {role}
        </p>
      </div>

      <div className="space-y-4">
        <button
          onClick={handleDeleteAllBooks}
          className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
        >
          Supprimer tous les livres
        </button>

        <button
          onClick={handleChangeSecondaryPassword}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
        >
          Changer le mot de passe secondaire
        </button>
      </div>
    </div>
  );
};

export default AdminPage;
